import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerStaticPromptTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution, type StaticPromptSolution } from "./solution";
import type { StaticPromptDefinition, StaticPromptProgress, StaticPromptSubmission } from "./types";

registerStaticPromptTranslations(i18n);

/** No `localFeedback`: the backend declares `live_feedback: false` for this type. */
export const staticPromptModule: PuzzleTypeModule<
  StaticPromptDefinition,
  StaticPromptSubmission,
  StaticPromptProgress,
  StaticPromptSolution
> = {
  key: "static_prompt",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
